<template>
  <Breadcrumb
    :items="items"
    :all-white="allWhite"
    :full-background="fullBackground"
    :with-brodos="withBrodos"
  />
</template>

<script setup lang="ts">
import { withDefaults, computed } from 'vue';
import Breadcrumb from '~/components/breadcrumb.vue';
import { useRoute } from '#imports';

export type SingleLevelBreadcrumbProps = {
  label?: string;
  allWhite?: boolean;
  fullBackground?: boolean;
  noLink?: boolean;
  withBrodos?: boolean;
};

const props = withDefaults(defineProps<SingleLevelBreadcrumbProps>(), {
  label: undefined,
});

const route = useRoute();

const items = computed(() => {
  if (!props.label) return [];
  if (props.noLink) return [{ label: props.label }];
  return [{ label: props.label, to: route?.path }];
});

defineExpose({ items });
</script>
